__turbopack_context__.v({
  "colourBlock": "photo-pack-module-scss-module__vzY0Vq__colourBlock",
  "credit": "photo-pack-module-scss-module__vzY0Vq__credit",
  "innerSkinTone": "photo-pack-module-scss-module__vzY0Vq__innerSkinTone",
  "lightbox": "photo-pack-module-scss-module__vzY0Vq__lightbox",
  "lightboxCopyright": "photo-pack-module-scss-module__vzY0Vq__lightboxCopyright",
  "lightboxFooter": "photo-pack-module-scss-module__vzY0Vq__lightboxFooter",
  "lightboxImageBoundingBox": "photo-pack-module-scss-module__vzY0Vq__lightboxImageBoundingBox",
  "nextLink": "photo-pack-module-scss-module__vzY0Vq__nextLink",
  "pagination": "photo-pack-module-scss-module__vzY0Vq__pagination",
  "paginationActive": "photo-pack-module-scss-module__vzY0Vq__paginationActive",
  "paginationBreak": "photo-pack-module-scss-module__vzY0Vq__paginationBreak",
  "paginationContainer": "photo-pack-module-scss-module__vzY0Vq__paginationContainer",
  "paginationDisabled": "photo-pack-module-scss-module__vzY0Vq__paginationDisabled",
  "paginationDisabledLink": "photo-pack-module-scss-module__vzY0Vq__paginationDisabledLink",
  "paginationNext": "photo-pack-module-scss-module__vzY0Vq__paginationNext",
  "paginationPrevious": "photo-pack-module-scss-module__vzY0Vq__paginationPrevious",
  "previousLink": "photo-pack-module-scss-module__vzY0Vq__previousLink",
  "skinTone": "photo-pack-module-scss-module__vzY0Vq__skinTone",
  "tile": "photo-pack-module-scss-module__vzY0Vq__tile",
});
